import React, { Component } from "react";
import PropTypes from "prop-types";
import { injectIntl, FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import messages from "components/messagesDescription";
import { ClientLogo } from "@cxagroup/casper";
import { Field, Select } from "cxa-components";
import LogoPP from "../common/LogoPP";
import FooterLogoPP from "../common/FooterLogoPP";
import GlobalMessageBoard from "../common/global-message-board";

const getRenderLanSelect = languages => props => {
  const options =
    languages &&
    languages.map(item => (
      <option key={item.id} value={item.id}>
        {item.name}
      </option>
    ));
  return <Select {...props}>{options}</Select>;
};

class LoginLayout extends Component {
  constructor(props) {
    super(props);
    this.onLanSelected = this.onLanSelected.bind(this);
  }

  onLanSelected(e) {
    const { clientName, localization, setLanguage } = this.props;
   
    setLanguage(clientName, e.target.value, localization);
  }

  render() {
    const {
      clientName,
      client,
      query,
      selectedLanguage,
      languages,
      logoUrl,
      faqUrl,
      faqLabel,
    } = this.props;

    const currentYear = new Date().getFullYear();
    const isCXAClient = client !== "libertyxchange";
    const isSignedUp = query.signup === "true";
    const { formatMessage } = this.props.intl;

    const urlTerms = formatMessage(messages.termsLink);
    const urlPrivacy = formatMessage(messages.privacyLink);
    const selectField = getRenderLanSelect(languages.all);

    let field = languages.all.length > 1 && (
      <Field
        name="languages"
        id="languages"
        field={selectField}
        defaultValue={!_.isEmpty(selectedLanguage) && selectedLanguage.id}
        value={selectedLanguage && selectedLanguage.id}
        onChange={this.onLanSelected}
        onBlur={this.onLanSelected}
        className="cxa-login__language"
      />
    );

    return (
      <div>
        <div
          style={{
            backgroundColor: "pink",
            position: "sticky",
            left: "0",
            top: "0",
            zIndex: "100",
          }}
        >
          <GlobalMessageBoard />
        </div>
        <div className="login-wrapper">
          <div className="login">
            <div className="login__brand">
              {logoUrl ? <ClientLogo client={client} logoUrl={logoUrl} size="large" /> : <LogoPP />}
            </div>
            <div className="login__form">
              {languages.all.length > 1 && (
                <Field
                  name="languages"
                  id="languages"
                  field={getRenderLanSelect(languages.all)}
                  defaultValue={!_.isEmpty(selectedLanguage) && selectedLanguage.id}
                  value={selectedLanguage && selectedLanguage.id}
                  onChange={this.onLanSelected}
                  onBlur={this.onLanSelected}
                  className="cxa-login__language"
                />
              )}
              {isSignedUp && <FormattedMessage {...messages.succeedSignedUpDescription} />}
              {this.props.children}
            </div>
          </div>
          <div className="login-footer">
            <nav className="login-footer__nav">
              <ul>
                <li>
                  <a
                    href={formatMessage(messages.termsLink)}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FormattedMessage {...messages.termsDescription} />
                  </a>
                </li>
                <li>
                  <a
                    href={formatMessage(messages.privacyLink)}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FormattedMessage {...messages.privacyDescription} />
                  </a>
                </li>
                <li>
                  <Link to="/contact">
                    <FormattedMessage {...messages.contactDescription} />
                  </Link>
                </li>
                {faqLabel && faqUrl && (
                  <li>
                    <a href={faqUrl} target="_blank" rel="noopener noreferrer">
                      <FormattedMessage id={faqLabel} defaultMessage={faqLabel} />
                    </a>
                  </li>
                )}
              </ul>
            </nav>
            {isCXAClient && (
              <section>
                {clientName && (
                  <div className="login-footer__engine">
                    <FormattedMessage {...messages.poweredByDescription} />
                    <FooterLogoPP width={48} height={48} />
                  </div>
                )}
                <p className="login-footer__copy">
                  &copy; {currentYear} <FormattedMessage {...messages.businessNameDescription} />
                </p>
              </section>
            )}
          </div>
        </div>
      </div>
    );
  }
}

LoginLayout.propTypes = {
  clientName: PropTypes.string.isRequired,
  client: PropTypes.string.isRequired,
  query: PropTypes.object.isRequired,
  selectedLanguage: PropTypes.object.isRequired,
  languages: PropTypes.object.isRequired,
  logoUrl: PropTypes.string,
  localization: PropTypes.object.isRequired,
  setLanguage: PropTypes.func.isRequired,
  faqUrl: PropTypes.string,
  faqLabel: PropTypes.string,
};

export default injectIntl(LoginLayout);



// WEBPACK FOOTER //
// ./components/login/LoginLayout.jsx